"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkClickTrackingWithDynamicContexts = exports.buttonClickTrackingWithDynamicContexts = exports.useSnowplowListener = exports.isReady = exports.useIsSnowplowReady = exports.useEnhancedPageView = exports.useComponentDisplay = exports.SnowplowProvider = void 0;
const Snowplow_1 = __importDefault(require("./src/react/Snowplow"));
const useEnhancedPageView_1 = __importDefault(require("./src/react/hooks/useEnhancedPageView"));
exports.useEnhancedPageView = useEnhancedPageView_1.default;
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
Object.defineProperty(exports, "buttonClickTrackingWithDynamicContexts", { enumerable: true, get: function () { return snowplow_js_common_1.buttonClickTrackingWithDynamicContexts; } });
Object.defineProperty(exports, "isReady", { enumerable: true, get: function () { return snowplow_js_common_1.isReady; } });
Object.defineProperty(exports, "linkClickTrackingWithDynamicContexts", { enumerable: true, get: function () { return snowplow_js_common_1.linkClickTrackingWithDynamicContexts; } });
const SnowplowProvider_1 = __importStar(require("./src/react/SnowplowProvider"));
exports.SnowplowProvider = SnowplowProvider_1.default;
Object.defineProperty(exports, "useIsSnowplowReady", { enumerable: true, get: function () { return SnowplowProvider_1.useIsSnowplowReady; } });
const useSnowplowListener_1 = __importDefault(require("./src/react/hooks/useSnowplowListener"));
exports.useSnowplowListener = useSnowplowListener_1.default;
const useComponentDisplay_1 = __importDefault(require("./src/react/hooks/useComponentDisplay"));
exports.useComponentDisplay = useComponentDisplay_1.default;
exports.default = Snowplow_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLG9FQUE0QztBQUM1QyxnR0FBd0U7QUFzQnBFLDhCQXRCRyw2QkFBbUIsQ0FzQkg7QUFyQnZCLGlFQUlrQztBQXFCOUIsdUhBeEJBLDJEQUFzQyxPQXdCQTtBQUZ0Qyx3RkFyQkEsNEJBQU8sT0FxQkE7QUFHUCxxSEF2QkEseURBQW9DLE9BdUJBO0FBZHhDLGlGQUFvRjtBQU9oRiwyQkFQRywwQkFBZ0IsQ0FPSDtBQUdoQixtR0FWdUIscUNBQWtCLE9BVXZCO0FBVHRCLGdHQUF3RTtBQVdwRSw4QkFYRyw2QkFBbUIsQ0FXSDtBQVZ2QixnR0FBd0U7QUFNcEUsOEJBTkcsNkJBQW1CLENBTUg7QUFKdkIsa0JBQWUsa0JBQVEsQ0FBQyJ9


// WEBPACK FOOTER //
// ../index.ts